import * as React from 'react';
import Settings, { ISettings } from '@app/models/builder/settings';
import { CurrencyKey } from '@common/util/currencies';

const defaultSettings = {};

export const SettingsContext = React.createContext(defaultSettings as Settings);